/**
 * Walidacja hasła po stronie klienta.
 *
 * Lustro polityki z backendu (`app/schemas/user.py`) — służy wyłącznie do
 * szybkiej podpowiedzi w formularzu. Decyzję zawsze podejmuje serwer.
 */

/**
 * Musi odpowiadać `PASSWORD_MIN_LENGTH` z `backend/app/core/config.py`.
 * Rozjazd oznacza, że formularz odrzuci hasło, które serwer by przyjął
 * (albo odwrotnie) — pilnuje tego test `polityka haseł`.
 */
export const PASSWORD_MIN_LENGTH = 8

export interface PasswordRule {
  label: string
  isMet: boolean
}

export function passwordRules(password: string): PasswordRule[] {
  return [
    {
      label: `Co najmniej ${PASSWORD_MIN_LENGTH} znaków`,
      isMet: password.length >= PASSWORD_MIN_LENGTH,
    },
    { label: 'Mała litera', isMet: /[a-ząćęłńóśźż]/.test(password) },
    { label: 'Wielka litera', isMet: /[A-ZĄĆĘŁŃÓŚŹŻ]/.test(password) },
    { label: 'Cyfra', isMet: /\d/.test(password) },
  ]
}

export function isPasswordValid(password: string): boolean {
  return passwordRules(password).every((rule) => rule.isMet)
}
